import { Typography, TypographyProps } from '@mui/material';

export default function BrandHeading(
  props: React.PropsWithChildren<TypographyProps>,
) {
  return (
    <Typography
      {...props}
      sx={{
        border: '0',
        borderLeft: '0.5rem',
        borderStyle: 'solid',
        borderColor: 'primary.light',
        paddingLeft: '1rem',
        ...props.sx,
      }}
    >
      {props.children}
    </Typography>
  );
}
